import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, useLocation, useNavigate, useSearchParams } from "react-router-dom";

import ErrorBoundry from "./Services/ErrorBoundry";
import { PostAxios, TokenExpireOnAPIRequest } from "./Services/RequestService";
import { ToastTemplate } from "./Services/Toast";
import { getFromLocal } from "./Services/UserAuth";
import { setInitialLoader, setMainLoading } from "./Store/reducers/Common";
import { setToastData, setToastDisplay } from "./Store/reducers/Toast";
import { logoutUser, setLogin } from "./Store/reducers/Users";
import UserLogin from "./Modules/Login";
import { ConvertErrorArrayToString } from "./Services/Common";
import AppRoutes from "./Routes";
export default function App() {
  const { accessToken, userData, loggingOut, isLoggedin } = useSelector(
    (state) => state.user
  );
  const location = useLocation();
  const { initialLoader, errorBoundry } = useSelector((state) => state.common);
  const { showToast, toastData } = useSelector((state) => state.toast);
  const [params] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (accessToken === "") {
      let fetchAccessToken = "";
      if (
        getFromLocal("accessToken") !== "" &&
        getFromLocal("accessToken") !== null
      ) {
        fetchAccessToken = getFromLocal("accessToken");
      }
      if (fetchAccessToken !== "") {
        PostAxios(`login-user`, {}, fetchAccessToken)
          .then(({ data }) => {
            if (data.error === "1") {
              dispatch(
                setToastData({
                  title:'Error',
                  message: (data.errors)?ConvertErrorArrayToString(data.errors):data.message,
                  isHtml: true,
                  type: "error",
                })
              );
              dispatch(logoutUser())
            } else if(data.status === "1") {
              dispatch(
                setLogin({
                  userData: data.data,
                  accessToken: fetchAccessToken,
                })
              );
              if (data.status === "2") {
                dispatch(
                  setToastData({
                    title:'Warning',
                    message: `Your access has been disabled. Please contact the admin for further details..`,
                    type: "warning",
                  })
                );
              }
              if (typeof navigate === "function") {
                navigate();
              }
            }
            dispatch(setInitialLoader(false));
          })
          .catch((err) => {
            console.log("err", err);
            TokenExpireOnAPIRequest(dispatch, err);
          });
      } else {
        dispatch(setInitialLoader(false));
        navigate("/login");
      }
    }
  }, [accessToken, params, dispatch, navigate]);

  if (initialLoader || loggingOut === true) {
    return (
      <div className="loading-img">
        <span className="loading-span">
          <svg className="circular" viewBox="25 25 50 50">
            <circle className="path" cx="50" cy="50" r="20" fill="none" strokeWidth="5" strokeMiterlimit="10" />
          </svg>
        </span>
      </div>
    );
  }
  return (
    <>
      {errorBoundry && <ErrorBoundry />}
      {!errorBoundry && isLoggedin && <AppRoutes />}
      {!errorBoundry && !isLoggedin && (
        <Routes>
          <Route path="/">
            <Route path="/login" index element={<UserLogin />} />
          </Route>
        </Routes>
      )}
      {
        <ToastTemplate
          activeClass={showToast ? "open-toast" : ""}
          toastData={toastData}
          toggleToast={() => dispatch(setToastDisplay(false))}
        />
      }
    </>
  );
}
